export default (editor, config = {}) => {
  const bm = editor.BlockManager;
  const pfx = 'emp-dateHeure';
  const style = `<style>
    .${pfx} {
    } 
    .${pfx}-container {
    align-items: baseline;
  display: flex !important;
  flex-direction: row;
  -webkit-flex-flow: row wrap;
  -webkit-border-radius: 0.2em;
  -moz-border-radius: 0.2em;
  border-radius: 0.2em;
    }
    .${pfx}-container-header {
    padding: 6px;
    font-family: Arial;
    }
    .${pfx}-container-content {
     display: flex;
     flex-direction: row;
    }
    .${pfx}-container-time-current {
      padding-left: 0.4em;
      padding-right: 0.4em;
    } 
    .${pfx}-container-date-current {
      display: flex;
      flex-direction: column;
      padding-left: 0.6em;
      justify-content: center;
      font-family: sans-serif;
    }
   
  </style>`;
  bm.add('dateHeure', {
    label: 'Date et Heure',
    title: 'Date et Heure',
    category: 'Widget',
    content: `
        <div   data-gjs-type="dateHeure"></div>
        ${style}
      `,
    attributes: {
      class: 'fa fa-calendar', //icon in the panel
    },
  });
};



// WEBPACK FOOTER //
// ./src/plugins/dateHeure/blocks.js